module.exports = __webpack_public_path__ + "assets/img/202112-6.682e7743.png";